import React, { useState, useEffect, useCallback } from 'react';
import * as PR from "../../prime-modules/index";
import "../login/Login.scss";
import { useDispatch } from 'react-redux';
import { adminAuthActions } from '../../store/adminAuth';
import { otpApi } from '../../services/api';
import { Helmet } from "react-helmet";
import { getBrandName } from "../../GlobalConfig";

const OTP = ({loginResponse, toast}) => {
    const [otp, setOtp] = useState('');
    const dispatch = useDispatch()
    const appName = process.env?.REACT_APP_NAME;

    const handleOTPSubmit = useCallback((currentOtp) => {
        const getOTPResponse = (response) => {
            if (response.result === "SUCCESS") {
                dispatch(adminAuthActions.onLogin(response?.data));
            } else if (response.result === "FAILED" && response.error) {
                const error = response.error;
                toast.current?.show({ severity: error.severity, summary:'Error', detail: (error.errorMsg) ? error.errorMsg : error.summary })
                setOtp('');
            }
        }
        otpApi({code:currentOtp,passKey:loginResponse?.passkey}, dispatch, getOTPResponse);
    }, [dispatch, loginResponse, toast]);

    useEffect(() => {
        if (otp && otp.length === 6) {
            handleOTPSubmit(otp);
        }
    }, [otp, handleOTPSubmit]);
    const customInput = ({events, props}) => <input {...events} {...props} type="text" className="custom-otp-input" autoComplete="off" />;
    return (
    <>
        <Helmet>
            <title>{`${getBrandName(appName)} | Backoffice`}</title>
        </Helmet>
        <section className="admin-login-section">
            <div className="grid grid-nogutter">
                <div className="col-12">
                    <div className="login-header flex align-items-center justify-content-between">
                        <PR.Image
                            src={`/brands/logos/${appName || "data2go"}-logo.png`}
                            loading="eager"
                            alt={`${getBrandName(appName)} Logo`}
                            onError={(e) => {
                            e.currentTarget.src = "/brands/logos/data2go-logo.png";
                            }}
                            className={`logo-img ${appName === "orzo" ? "orzo-logo" : ""}`}
                        />
                        <h1>Backoffice Login</h1>
                    </div>
                    <div className="login-wrapper otp-wrapper">
                        <h6>Please enter the One Time Password (OTP) <br/> sent to your email below.</h6>
                            <div className='grid'>
                                <div className="col-12 md:col-12">
                                    <div className="card flex justify-content-center">
                                        <PR.InputOtp value={otp} onChange={(e) => setOtp(e.value)} inputTemplate={customInput} length={6} integerOnly/>
                                    </div>
                                </div>
                                {/* <div className="col-12 mt-3 navigate">
                                    <PR.Button label="Login" disabled={otp.length < 6} onClick={()=>handleOTPSubmit(false)}  className="login-btn w-12" />
                                </div> */}
                            </div>
                    </div>
                    <footer className='footer-block'>
                        <p>Powered by <a href="https://data2go.mobi/" target="_blank" rel="noreferrer">data2go.mobi</a></p>
                    </footer>
                </div>
            </div>
        </section>
    </>
  );
};

export default OTP;